/**
 * Single source of truth for "has this visitor given us their email" and
 * "has this visitor tasted a sample". Once either flag is set, gates and
 * popups stay quiet on this browser.
 */

const KEY = "aperture_captured";
const SAMPLED_KEY = "aperture_sampled";
const EXIT_INTENT_SEEN_KEY = "aperture_exit_intent_seen";

export function isCaptured() {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}
export function markCaptured() {
  try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
}

/** Set when the visitor opens any sample (PDF preview or audio preview). */
export function isSampled() {
  try { return localStorage.getItem(SAMPLED_KEY) === "1"; } catch { return false; }
}
export function markSampled() {
  try { localStorage.setItem(SAMPLED_KEY, "1"); } catch { /* ignore */ }
}

/** Prevents the exit-intent hook from re-firing on the same session. */
export function markExitIntentSeen() {
  try { sessionStorage.setItem(EXIT_INTENT_SEEN_KEY, "1"); } catch { /* ignore */ }
}
export function wasExitIntentSeen() {
  try { return sessionStorage.getItem(EXIT_INTENT_SEEN_KEY) === "1"; } catch { return false; }
}
